<template>
  <li class="__presentation-search">
    <a class="__dropdown-item-search">
      <b-input-group>
        <template #prepend>
          <b-input-group-text>
            <GjIcon
              name="Search"
              size="20"
            />
          </b-input-group-text>
        </template>
        <b-form-input
          v-if="data.hasOwnProperty('propertySearch')"
          v-model.lazy="data.propertySearch"
          v-debounce="searchChange"
          type="text"
          class="d-inline-block __dropdown-search"
          size="sm"
          :placeholder="$tk('ClientPortal.Form.SearchPlaceholder')"
        />
        <b-form-input
          v-else
          v-model.lazy="data.search"
          v-debounce="searchChange"
          type="text"
          class="d-inline-block __dropdown-search"
          size="sm"
          :placeholder="$tk('ClientPortal.Form.SearchPlaceholder')"
        />
      </b-input-group>

    </a>
  </li>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import vueDebounce from 'vue-debounce'
import Vue from 'vue'

Vue.use(vueDebounce)
Vue.use(vueDebounce, {
  listenTo: 'input',
  defaultTime: '700ms',
})

export default {
  components: {
    GjIcon,
  },
  props: {
    data: {
      type: [Object, Array],
    },
  },
  setup(props, context) {
    const searchChange = () => {
      context.emit('searchChange')
    }

    return {
      searchChange,
    }
  },
  methods: {

  },
}
</script>

<style lang="scss">

.__presentation-search {
  display: flex;
  align-items: center;
  width: 100%;
  height: 34px;
  padding: 0px 4px 0px 12px;
  border-radius: 0.358rem;
  -webkit-border-radius: 0.358rem;
  -moz-border-radius: 0.358rem;
  -ms-border-radius: 0.358rem;
  -o-border-radius: 0.358rem;
  font-size: 14px;
  color: #667c99;
  cursor: pointer;
  &:hover {
    color: #1d79f2;
    background-color:#fafafa;
  }
  & > a.__dropdown-item-search{
      display: flex;
      align-items: center;
      width: inherit;
      height: 34px;
      transition: all 0.25s;
      input.__dropdown-search{
          border: 0;
          border-bottom: 1px solid #d8d6de;
          border-radius: 0;
          max-height: 25px;
          font-size: 12px;
          padding: 0.15rem 0.2rem;
      }
      .input-group-prepend {
              .input-group-text{
                border: 0;
                border-bottom: 1px solid #d8d6de;
                border-radius: 0;
                max-height: 25px;
                font-size: 12px;
                padding: 4px;
              }
          }
  }
}
</style>
